import Vue from 'vue';

export default {
	namespaced: true,
	state: {
		columns: { left: [], right: [] }
	},
	mutations: {
		setColumns(state, data) {
			state.columns = data;
		},
		moveItem(state, data) {
			// { target: "right", item: {name:"sig-chat", id:"1"}, index: 0 }
			let column = data.target === 'right' ? state.columns.left : state.columns.right;
			let item = column[data.index];
			column.splice(data.index, 1);
			state.columns[data.target].push(item);
		},
		addComponent(state, data) {
			// data: { column: 'left', component: 'sig-quotetable' }
			let id = findFreeWidgetId(state.columns, data.component);
			state.columns[data.column].push({ name: data.component, widgetid: id });
		},
		dropComponent(state, data) {
			// data: { column: 'right', name: 'sig-chat', id: '2' }
			let index = -1;
			for (let i = 0; i < state.columns[data.column].length; i++) {
				let w = state.columns[data.column][i];
				if (w.widgetid === data.id && w.name === data.name) {
					index = i;
					break;
				}
			}
			if (index < 0) return;
			state.columns[data.column].splice(index, 1);
		}
	},
	getters: {
		getColumns(state) {
			return state.columns;
		},
		getColumn(state) {
			return (col) => { return state.columns[col]; };
		},
		getLeftColumnWidgets(state) {
			return state.columns.left;
		},
		getRightColumnWidgets(state) {
			return state.columns.right;
		}
	},
	actions: {
		applyColumns(state, data) {
			state.commit('setColumns', data);
			saveSettings(data);
		},
		loadSettings(state) {
			let columns = readSettings();
			state.commit('setColumns', columns);
		},
		moveComponent(state, data) {
			// data: { target: "right", item: {name:"sig-chat", id:"1"} }
			data = JSON.parse(data);
			let widgets = data.target === 'right' ? state.getters['getLeftColumnWidgets'] 
				: state.getters['getRightColumnWidgets'];
			for (let i = 0; i < widgets.length; i++) {
				if (widgets[i].name != data.item.name || widgets[i].widgetid != data.item.id)
					continue;
				state.commit('moveItem', { target: data.target, item: data.item, index: i });
				break;
			}
			saveSettings(state.getters['getColumns']);
		},
		addComponent(state, data) {
			// data: { column: 'left', component: 'sig-quotetable' }
			state.commit('addComponent', data);
			saveSettings(state.getters['getColumns']);
		},
		dropComponent(state, data) {
			// data: { column: column, name: widget.name, id: widget.id }
			state.commit('dropComponent', data);
			saveSettings(state.getters['getColumns']);
		}
	}
}

function saveSettings(settings) {
	let json = JSON.stringify(settings);
	localStorage.setItem('widgetSettings', json);
}

function readSettings() {
	let defaultColumns = { left: [ 
			{ name: 'sig-quotetable', widgetid: '1'},
			{ name: 'sig-chat', widgetid: '1'}
		], right: [] };
	let json = localStorage.getItem('widgetSettings');
	if (!json) return defaultColumns;
	let raw = null;
	try {
		raw = JSON.parse(json);
	} catch (e) {
		return defaultColumns;
	}
	if (!raw.left || !raw.right) return defaultColumns;
	return raw;
}

function findFreeWidgetId(panes, widgetName) {
	let ids = [];
	for (let key in panes)
		for (let j = 0; j < panes[key].length; j++) {
			let w = panes[key][j];
			if (w.name === widgetName) ids.push(w.widgetid);
		}
	if (ids.length === 0) return 1;
	for (let id = 1; id < 1000; id++) {
		let found = false;
		for (let i = 0; i < ids.length; i++) {
			if (ids[i] === (id + '')) {
				found = true;
				break;
			}
		}
		if (!found) return id + '';
	}
	return '9999';
}